import { __extends } from "tslib";
import { AnalyzeDocumentRequest, AnalyzeDocumentResponse } from "../models/models_0";
import { deserializeAws_json1_1AnalyzeDocumentCommand, serializeAws_json1_1AnalyzeDocumentCommand, } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var AnalyzeDocumentCommand = /** @class */ (function (_super) {
    __extends(AnalyzeDocumentCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function AnalyzeDocumentCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    AnalyzeDocumentCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "TextractClient";
        var commandName = "AnalyzeDocumentCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: AnalyzeDocumentRequest.filterSensitiveLog,
            outputFilterSensitiveLog: AnalyzeDocumentResponse.filterSensitiveLog,
        };
        if (typeof logger.info === "function") {
            logger.info({
                clientName: clientName,
                commandName: commandName,
            });
        }
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    AnalyzeDocumentCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1AnalyzeDocumentCommand(input, context);
    };
    AnalyzeDocumentCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1AnalyzeDocumentCommand(output, context);
    };
    return AnalyzeDocumentCommand;
}($Command));
export { AnalyzeDocumentCommand };
//# sourceMappingURL=AnalyzeDocumentCommand.js.map